<template>
  <div>
    <h2>Mod Stats</h2>
    <h4>Total number of mods: {{ mods.length }}</h4>
    <section>
      <Filter
        @change="(slots) => (selectedSlot = slots)"
        title="Slot"
        :values="slots"
        v-slot="{ value }"
        :multiple="false"
      >
        <Icon
          :show-set="false"
          :show-toon="false"
          size="small"
          :mod="{ slot: value }"
        />
      </Filter>
    </section>
    <br />
    <stat-svg
      v-for="s in secondaries"
      :stat-values="secondary(s).values"
      :stat-name="s"
    />
  </div>
</template>
<script>
import Filter from "./Filter.vue";
import Icon from "./Icon.vue";
import StatSvg from "./StatSvg.vue";

export default {
  props: {
    mods: {
      type: Array,
      default: [],
    },
  },
  components: { StatSvg, Filter, Icon },
  data() {
    return {
      secondaries: [
        "Speed",
        "Critical Chance%",
        "Offense",
        "Offense%",
        "Health",
        "Health%",
        "Protection",
        "Protection%",
        "Defense",
        "Defense%",
        "Tenacity%",
        "Potency%",
      ],
      slots: [
        { label: "Square", value: 0 },
        { label: "Arrow", value: 1 },
        { label: "Diamond", value: 2 },
        { label: "Triangle", value: 3 },
        { label: "Circle", value: 4 },
        { label: "Cross", value: 5 },
      ],
      selectedSlot: null,
    };
  },
  computed: {
    stats() {
      return this.mods
        .filter((mod) => {
          if (this.selectedSlot == null) {
            return true;
          }
          return mod.slot == this.selectedSlot;
        })
        .reduce(
          (stats, mod) => {
            const primaryName = mod.primaryStat.name;
            const secondaries = mod.secondaryStat.map((secondary) => [
              secondary.name + secondary.unitSign,
              secondary,
            ]);
            return {
              primaries: {
                ...stats.primaries,
                [primaryName]: {
                  count:
                    (stats.primaries[primaryName] || { count: 0 }).count + 1,
                },
              },
              secondaries: {
                ...stats.secondaries,
                ...Object.fromEntries(
                  secondaries.map(([name, modSecondary]) => {
                    const secondary = stats.secondaries[name] || {
                      values: [],
                    };
                    return [
                      name,
                      {
                        values: [...secondary.values, modSecondary.value],
                      },
                    ];
                  })
                ),
              },
            };
          },
          { primaries: {}, secondaries: {} }
        );
    },
  },
  methods: {
    primary(name) {
      return this.stats.primaries[name];
    },
    secondary(name) {
      return this.stats.secondaries[name] || { values: [] };
    },
  },
};
</script>
